import React from "react";
import DemoPanel from "./Components/DemoPanel";

function App() {
  return (
    <div className="h-svh w-svh bg-slate-100">
      <DemoPanel className="bg-slate-600" />
    </div>
  );
}

export default App;
